module.exports = __webpack_public_path__ + "img/0.9a5fa863.webp";